import { reactive } from '@vue/composition-api';
import { PhotoModalState } from '@/models/photoModal';
import { StandardReportPhotoExt } from '@/models/externalReports/standard/standardReport';
import { dtFormat } from '@/lib/dateHelper';

export interface UsePhotoModalResult {
  photoModalState: PhotoModalState;
  showPhotoModal: (photoType: string, photos: StandardReportPhotoExt[]) => void;
  hidePhotoModal: () => void;
}
export function usePhotoModal(): UsePhotoModalResult {
  const photoModalState = reactive<PhotoModalState>({
    shouldShowPhotoModal: false,
    title: '',
    photos: [],
  });

  const showPhotoModal = (photoType: string, photos: StandardReportPhotoExt[]) => {
    photoModalState.title = photoType + '写真';
    photoModalState.photos = photos.map((photo) => ({
      id: photo.id,
      photoTitle: photo.dispOrder + '. ' + dtFormat(photo.ts),
      savedImage: photo.savedImage,
    }));
    photoModalState.shouldShowPhotoModal = true;
  };
  const hidePhotoModal = () => {
    photoModalState.shouldShowPhotoModal = false;
    photoModalState.title = '';
    photoModalState.photos = [];
  };

  return {
    photoModalState,
    showPhotoModal,
    hidePhotoModal,
  };
}
